import React, { useState } from "react";
import {
  Box,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormGroup,
  Checkbox,
  Button,
} from "@mui/material";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import StripeCheckout from "../../Reservation/StripeCheckout";

const PaymentSelection = ({
  updatedTotalRentalValue,
  setPaymentIntentId,
  setPaymentAproved,
  setUpdatedTotalRentalValue,
  setPaymentType,
  paymentType,
  setTotalRentalValue,
}) => {
  const [paymentValue, setPaymentValue] = useState(
    Number(updatedTotalRentalValue).toFixed(2)
  );
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [proceedPayment, setProceedPayment] = useState(false);

  const { t } = useTranslation();

  const handlePaymentTypeChange = (event) => {
    const value = event.target.value;
    setPaymentType(value);

    if (value === "partial") {
      const partialAmount = Number((updatedTotalRentalValue * 0.2).toFixed(2));
      setPaymentValue(partialAmount);
      setTotalRentalValue(partialAmount);
    } else {
      const fullAmount = Number(updatedTotalRentalValue?.toFixed(2));
      setPaymentValue(fullAmount);
      setTotalRentalValue(fullAmount);
    }
  };

  const onSuccess = (paymentIntent) => {
    const paidAmount = (paymentIntent.amount / 100).toFixed(2);
    setUpdatedTotalRentalValue(paidAmount);
    setPaymentIntentId(paymentIntent.id);
    setPaymentAproved(true);
  };

  const onError = (error) => {
    console.error("Stripe payment error:", error);
  };

  return (
    <Box sx={{ maxWidth: "600px", margin: "0 auto", padding: "20px", boxShadow: 3 }}>
      {/* Payment Type Selection */}
      <Box sx={{ backgroundColor: "primary.main", color: "#fff", padding: "10px" }}>
        <Typography variant="h6" align="center">
          {t("choosePaymentMode")}
        </Typography>
      </Box>
      <FormControl component="fieldset" sx={{ mt: 2 }}>
        <RadioGroup value={paymentType} onChange={handlePaymentTypeChange}>
          <FormControlLabel
            value="partial"
            control={<Radio />}
            label={
              <Box>
                <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                  {t("partialPrice")}
                </Typography>
                <Typography variant="body2">{t("pay20Now80Later")}</Typography>
                <Typography variant="h6" color="error">
                  {Number((updatedTotalRentalValue * 0.2).toFixed(2))}€
                </Typography>
              </Box>
            }
          />
          <FormControlLabel
            value="full"
            control={<Radio />}
            label={
              <Box>
                <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                  {t("totalPrice")}
                </Typography>
                <Typography variant="h6" color="error">
                  {Number(updatedTotalRentalValue).toFixed(2)}€
                </Typography>
              </Box>
            }
          />
        </RadioGroup>
      </FormControl>

      {/* Terms and Conditions */}
      <Box sx={{ backgroundColor: "primary.main", color: "#fff", padding: "10px", marginTop: "20px" }}>
        <Typography variant="h6" align="center">
          {t("termsAndConditions")}
        </Typography>
      </Box>
      <FormGroup sx={{ mt: 2 }}>
        <FormControlLabel
          control={
            <Checkbox checked={termsAccepted} onChange={(e) => setTermsAccepted(e.target.checked)} color="primary" />
          }
          label={
            <Typography variant="body2" component="span">
              {t("readAndAccepted")}{" "}
              <Typography variant="body2" component="span" sx={{ color: "primary.main", textDecoration: "underline" }}>
                <Link target="_blank" to="/termsAndConditions">
                  {t("termsAndConditions")}
                </Link>
              </Typography>
            </Typography>
          }
        />
      </FormGroup>

      {!proceedPayment && (
        <Button
          variant="contained"
          color="primary"
          fullWidth
          sx={{ mt: 3 }}
          disabled={!termsAccepted}
          onClick={() => setProceedPayment(true)}
        >
          {t("proceedPayment")}
        </Button>
      )}

      {proceedPayment && (
        <>
          <Box sx={{ backgroundColor: "primary.main", color: "#fff", padding: "10px", marginTop: "20px" }}>
            <Typography variant="h6" align="center">
              {t("choosePaymentMethod")}
            </Typography>
          </Box>
          <StripeCheckout
            amount={paymentValue}
            onSuccess={onSuccess}
            onError={onError}
          />
        </>
      )}
    </Box>
  );
};

PaymentSelection.propTypes = {
  updatedTotalRentalValue: PropTypes.any,
  setPaymentIntentId: PropTypes.func,
  setPaymentAproved: PropTypes.any,
  setUpdatedTotalRentalValue: PropTypes.any,
  setPaymentType: PropTypes.any,
  paymentType: PropTypes.any,
  setTotalRentalValue: PropTypes.any,
};

export default PaymentSelection;
